/**
 * LA TRIBUNA — Social Proof Notifications
 * Notificaciones de compras recientes. Discretas, profesionales, mobile-first.
 */
(function () {
  'use strict';
  const PRODUCTS = [
    'Camisa España Mundial', 'Camisa Argentina Mundial', 'Camisa Brasil Mundial',
    'Camisa Francia Mundial', 'Camisa Alemania Mundial', 'Camisa España Mundial',
    'Camisa Barcelona 2009 Champions', 'Camisa Santos Retro 2012',
    'Camisa Arsenal Local 25-26', 'Camisa Atletico Madrid 25-26',
    'Camisa Aston Villa 25-26', 'Camisa Lyon 2025/26',
    'Camisa Real Madrid 25-26', 'Camisa Manchester City 25-26',
    'Camisa Liverpool 25-26', 'Camisa Boca Juniors Retro',
    'Camisa Inter Milan 25-26', 'Camisa PSG 25-26',
  ];
  const BUYERS = [
    { name: 'Carlos R.', city: 'Bogotá', country: 'Colombia' },
    { name: 'Laura M.', city: 'Medellín', country: 'Colombia' },
    { name: 'Pablo L.', city: 'Cali', country: 'Colombia' },
    { name: 'Marta G.', city: 'Barranquilla', country: 'Colombia' },
    { name: 'Javier T.', city: 'Cartagena', country: 'Colombia' },
    { name: 'Ana V.', city: 'Bucaramanga', country: 'Colombia' },
    { name: 'Roberto P.', city: 'Pereira', country: 'Colombia' },
    { name: 'Elena B.', city: 'Manizales', country: 'Colombia' },
    { name: 'Isabel F.', city: 'Bogotá', country: 'Colombia' },
    { name: 'Carmen C.', city: 'Cúcuta', country: 'Colombia' },
    { name: 'Sofía R.', city: 'Medellín', country: 'Colombia' },
    { name: 'Miguel H.', city: 'Lima', country: 'Perú' },
    { name: 'Rodrigo S.', city: 'Santiago', country: 'Chile' },
    { name: 'Gabriel M.', city: 'São Paulo', country: 'Brasil' },
    { name: 'Javier O.', city: 'Ciudad de México', country: 'México' },
    { name: 'Martín A.', city: 'Buenos Aires', country: 'Argentina' },
    { name: 'Pablo N.', city: 'Montevideo', country: 'Uruguay' },
    { name: 'Daniel Q.', city: 'Quito', country: 'Ecuador' },
  ];
  const TIMES = ['hace 2 min','hace 4 min','hace 7 min','hace 11 min','hace 15 min','hace 23 min','hace 34 min','hace 47 min','hace 1 hora','hace 2 horas'];

  let el = null, timer = null, queue = [], idx = 0;
  const rnd = a => a[Math.floor(Math.random()*a.length)];
  const shuffle = a => { const x=[...a]; for(let i=x.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[x[i],x[j]]=[x[j],x[i]];} return x; };
  function buildQueue(){ queue = shuffle(PRODUCTS).map(p=>({product:p,buyer:rnd(BUYERS),time:rnd(TIMES)})); idx=0; }

  function inject(){
    const style = document.createElement('style');
    style.id='lt-sp-css';
    style.textContent = `#lt-sp{position:fixed;bottom:20px;left:16px;z-index:9999;max-width:290px;width:calc(100vw - 32px);transform:translateY(calc(100% + 20px));opacity:0;transition:transform .4s cubic-bezier(.34,1.3,.64,1),opacity .3s ease;pointer-events:none}#lt-sp.lt-sp-on{transform:translateY(0);opacity:1;pointer-events:auto}#lt-sp-box{background:#161616;border:1px solid rgba(255,255,255,.1);border-radius:14px;padding:11px 13px 11px 11px;display:flex;align-items:center;gap:9px;box-shadow:0 10px 40px rgba(0,0,0,.6)}#lt-sp-ic{width:38px;height:38px;border-radius:10px;background:rgba(180,0,0,.18);display:flex;align-items:center;justify-content:center;font-size:1.25rem;flex-shrink:0}#lt-sp-bd{flex:1;min-width:0}#lt-sp-who{font-size:.7rem;font-weight:700;color:rgba(255,255,255,.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#lt-sp-prd{font-size:.68rem;color:rgba(255,255,255,.55);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:.15rem 0}#lt-sp-meta{font-size:.62rem;color:#4caf82;font-weight:700;display:flex;align-items:center;gap:4px}#lt-sp-meta::before{content:'';width:5px;height:5px;background:#4caf82;border-radius:50%;flex-shrink:0}#lt-sp-cls{background:none;border:none;color:rgba(255,255,255,.25);font-size:.65rem;cursor:pointer;padding:3px 5px;flex-shrink:0;line-height:1;transition:color .2s;align-self:flex-start;margin-top:2px}#lt-sp-cls:hover{color:rgba(255,255,255,.65)}@media(max-width:400px){#lt-sp{bottom:14px;left:10px;max-width:calc(100vw - 20px)}}`;
    document.head.appendChild(style);
    el = document.createElement('div');
    el.id='lt-sp'; el.setAttribute('role','status'); el.setAttribute('aria-live','polite');
    el.innerHTML = `<div id="lt-sp-box"><div id="lt-sp-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2l2.6 12.4a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L21 8H6"/></svg></div><div id="lt-sp-bd"><div id="lt-sp-who"></div><div id="lt-sp-prd"></div><div id="lt-sp-meta"></div></div><button id="lt-sp-cls" aria-label="Cerrar">✕</button></div>`;
    document.body.appendChild(el);
    el.querySelector('#lt-sp-cls').addEventListener('click',()=>hide(true));
  }

  function show(d){
    if(!el) inject();
    el.querySelector('#lt-sp-who').textContent = `${d.buyer.name} compró`;
    el.querySelector('#lt-sp-prd').textContent = d.product;
    el.querySelector('#lt-sp-meta').textContent = `${d.time} · ${d.buyer.city}, ${d.buyer.country}`;
    el.classList.remove('lt-sp-on');
    requestAnimationFrame(()=>requestAnimationFrame(()=>el.classList.add('lt-sp-on')));
    clearTimeout(timer);
    timer = setTimeout(()=>hide(false),5800);
  }
  function hide(permanent){
    if(el) el.classList.remove('lt-sp-on');
    clearTimeout(timer);
    if(!permanent) timer = setTimeout(next, 20000+Math.random()*25000);
  }
  function next(){ if(idx>=queue.length) buildQueue(); show(queue[idx++]); }
  function init(){ buildQueue(); timer = setTimeout(next, 9000+Math.random()*7000); }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
